
import { useState, useEffect } from 'react';

import { getList } from 'api/prescribedHours';
import PrescribedHoursDomain from 'domain/master/labor/prescribedHours';

export const usePrescribedHoursList = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [prescribedList, setPrescribedList] = useState<Array<PrescribedHoursDomain>>([]);
  useEffect(() => {
    setIsLoading(true);
    let isSubscribed = true;
    const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
    getList(companyCode).then((response: Array<any>) => {
      setIsLoading(false);
      if (isSubscribed) {
        setPrescribedList(response.map((result) => new PrescribedHoursDomain(result)));
      }
    });
    return () => { isSubscribed = false; };
  }, []);
  return { prescribedList, setPrescribedList, isLoading };
};

export default usePrescribedHoursList;
